import style from './InstallmentsPageView.css';
import Title from '../../shared/Typography/Title';
import useTranslation from '../../../localization/i18n.context';
import List from '../../shared/List/List';
import ListItem from '../../shared/List/ListItem';
import BodyText from '../../shared/Typography/BodyText';
import Button from '../../shared/Button/Button';
import FormatterUtils from '../../../utils/formatter.utils';
import { renderIf } from '../../../utils/render.utils';
import { useState } from 'preact/hooks';
import NavigationUtils from '../../../utils/navigation.utils';
import { EnterAmountType } from '../../../routes/EnterAmountPage/EnterAmountProvider';

export default function InstallmentsPageView({
  className = '',
  installments = [],
  currency = '',
  organizationCode = '',
}) {
  const { t, getCurrency } = useTranslation();
  const [selectedInstallment, setSelectedInstallments] = useState(null);
  const isButtonEnabled = selectedInstallment != null;

  function onContinueButtonClick() {
    return NavigationUtils.navigate(NavigationUtils.Routes.SUMMARY, false, {
      organizationCode: organizationCode,
      currency: currency,
      amount: selectedInstallment?.amount.toString(),
      type: EnterAmountType.MICROLOAN,
      id: selectedInstallment?.id,
    });
  }

  return (
    <main className={`${style.container} ${className}`}>
      <Title text={t('How many installments?')} className={style.title} />
      <BodyText
        text={t('Select number of installments')}
        className={style.subtitle}
      />
      {renderIf(
        installments.length > 0,
        <List className={style.list}>
          {installments.map(installment => (
            <ListItem
              title={t(
                '{installment number} payments of {installment amount}',
                {
                  '{installment number}': installment.installments,
                  '{installment amount}': FormatterUtils.currency(
                    installment.monthlyPayment,
                    getCurrency(),
                  ),
                },
              )}
              subtitle={t('Total amount to pay {total amount}', {
                '{total amount}': FormatterUtils.currency(
                  installment.total,
                  getCurrency(),
                ),
              })}
              actionable
              type={ListItem.Type.CHECKBOX}
              size={ListItem.Size.SMALL}
              selected={selectedInstallment?.id === installment.id}
              onClick={() => {
                setSelectedInstallments(installment);
              }}
            />
          ))}
        </List>,
      )}
      <div className="fixed-cta">
        <Button
          fullWidth
          onClick={onContinueButtonClick}
          disabled={!isButtonEnabled}
        >
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
